<app-items-inner
  [sidebarComponent]="sidebarComponent()"
  [instancesComponent]="instancesComponent()"
/>
@if (!dataService.exists()) {
  <app-instruction />
}
